var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    stroke: "white",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5013 18.3307H12.5013C16.668 18.3307 18.3346 16.6641 18.3346 12.4974V7.4974C18.3346 3.33073 16.668 1.66406 12.5013 1.66406H7.5013C3.33464 1.66406 1.66797 3.33073 1.66797 7.4974V12.4974C1.66797 16.6641 3.33464 18.3307 7.5013 18.3307Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58203 9.99828V8.76495C7.58203 7.17328 8.70703 6.53162 10.082 7.32328L11.1487 7.93995L12.2154 8.55662C13.5904 9.34828 13.5904 10.6483 12.2154 11.4399L11.1487 12.0566L10.082 12.6733C8.70703 13.465 7.58203 12.815 7.58203 11.2316V9.99828Z",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4415cd161c34fa677e53a79fede2ce22.svg";
export { ForwardRef as ReactComponent };